<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
  import {mapGetters} from 'vuex'
  import SidebarItem from './SidebarItem'
  import ScrollBar from '@/components/ScrollBar'
  import Layout from '@/views/layout/Layout'

  export default {
    components: {SidebarItem, ScrollBar},
    computed: {
      ...mapGetters([
        'sidebar'
      ]),
      routes() {

        if (this.$store.state.user.roles == '0') {
          let constantRouterMap = [
            {path: '/login', component: () => import('@/views/login/index'), hidden: true},
            {path: '/404', component: () => import('@/views/404'), hidden: true},
            {
              path: '',
              component: Layout,
              redirect: '/home',
              children: [{
                path: 'home',
                name: 'home',
                component: () => import('@/views/home/index'),
                meta: {title: '首页', icon: 'home'}
              }]
            },
            {
              path: '/base',
              component: Layout,
              redirect: '/base/user/',
              name: 'base',
              meta: {title: '用户', icon: 'product-list'},
              children: [{
                path: 'user',
                name: 'user',
                component: () => import('@/views/sys/user/index'),
                meta: {title: '用户管理', icon: 'product-list'}
              },
              ]
            },

            {
              path: '/recharge',
              component: Layout,
              redirect: '/recharge/list/',
              name: 'recharge',
              meta: {title: '订单管理', icon: 'product-list'},
              children: [
                {
                  path: 'order',
                  name: 'order',
                  component: () => import('@/views/taskorder/order'),
                  meta: {title: '充值订单', icon: 'product-list'}
                }
                // ,
                // {
                //   path: 'rechargeIndex',
                //   name: 'rechargeIndex',
                //   component: () => import('@/views/system/rechargeIndex'),
                //   meta: {title: '充值规格设置', icon: 'product-list'}
                // },
              ]
            },
            {path: '*', redirect: '/404', hidden: true}
          ]
          return constantRouterMap;
        } else {
          return this.$router.options.routes
        }
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue